@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card planning-form-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">New Activity</h3>
    @if (code) {
      <span class="badge planning-code-badge">{{ code }}</span>
    }
  </div>

  <div class="card-body">
    <form [formGroup]="form">
      <div class="row">

        <div class="col-lg-6 col-md-12">
          <h5 class="planning-section-title">Details</h5>

          <input-field
            label="Title"
            placeholder="Short title of the activity"
            [inputFormControl]="getControl('title')"
            [type]="'text'">
          </input-field>

          <textarea-field
            label="Description"
            placeholder="Describe what has to be done and why"
            [height]="200"
            [textareaFormControl]="getControl('description')">
          </textarea-field>
        </div>

        <div class="col-lg-3 col-md-6">
          <h5 class="planning-section-title">People</h5>

          <label class="fw-bold planning-field-label">
            <i class="fa fa-user me-1"></i>Assignee
          </label>
          <select-field
            [selectFormControl]="getControl('assigneeUserId')"
            [options]="assigneeOptions">
          </select-field>

          <label class="fw-bold planning-field-label mt-3">Reported by</label>
          <input type="text" class="form-control" [value]="reportedByLabel" placeholder="Current user" readonly disabled />
        </div>

        <div class="col-lg-3 col-md-6">
          <h5 class="planning-section-title">Dates</h5>

          <div class="form-group">
            <label class="fw-bold planning-field-label">
              <i class="fa fa-clock-o me-1"></i>Due Date
            </label>
            <input
              type="datetime-local"
              class="form-control"
              formControlName="dueDate"
              [class.is-invalid]="hasError('dueDate')" />
            @if (hasError('dueDate')) {
              <div class="text-danger small">
                <i class="fa fa-exclamation-circle me-1"></i>{{ errorMessage('dueDate') }}
              </div>
            }
          </div>

          <div class="form-group mt-3">
            <label class="fw-bold planning-field-label">
              <i class="fa fa-bell me-1"></i>Reminder
            </label>
            <input
              type="datetime-local"
              class="form-control"
              formControlName="reminder"
              (change)="onReminderChange()" />
            @if (!isCreator) {
              <small class="text-muted">Only the reporter can change the reminder.</small>
            }
          </div>

          @if (isEditMode && !isCompleted && canModify) {
            <div class="mt-3">
              <activities-planning-postpone
                [postponedReason]="planning?.postponedReason ?? null"
                (onPostpone)="onPostpone($event)">
              </activities-planning-postpone>
            </div>
          }
        </div>

      </div>
    </form>
  </div>

  @if (canModify) {
    <div class="card-footer">
      <div class="d-flex justify-content-center align-items-center gap-2 my-2">
        <button type="button" class="btn btn-primary" (click)="submitForm()">Save and send notification</button>
        @if (isEditMode && !isCompleted) {
          <button type="button" class="btn btn-success" (click)="markAsDone()">Mark as Done</button>
        }
      </div>
    </div>
  }
</div>
